<template>
    <div class="nav top" :data-is-home="isHomePage">
        <div class="nav-content">
            <div class="nav-left">
                <router-link to="/" class="nav-item" >
                    <i class="adilfont icon-logo2"  style="font-size: 25px"></i>
                </router-link>
            </div>
            <div class="nav-center">
                <div class="mobile-buttons" v-show="isMobile">
                    <el-button class="back-to-top-button" @click="scrollToTop" v-show="showBackToTop">
                        <el-icon><Top /></el-icon>
                        返回顶部
                    </el-button>
                    <el-button class="menu-button" @click="drawer = true">
                        <el-icon><Menu /></el-icon>
                        菜单
                    </el-button>
                </div>
                <el-drawer
                    v-model="drawer"
                    direction="rtl"
                    size="60%"
                    :with-header="false"
                    v-if="isMobile"
                    append-to-body
                >
                    <div class="drawer-content">
                        <router-link to="/" class="nav-item" :class="{ 'active': isHomePage }" @click="drawer = false">
                            <el-icon><House /></el-icon> 首页
                        </router-link>
                        <router-link to="/price" class="nav-item" :class="{ 'active': currentRoute === '/price' }" @click="drawer = false">
                            <el-icon><PriceTag /></el-icon> 价格
                        </router-link>
                        <router-link to="/display" class="nav-item" :class="{ 'active': currentRoute === '/display' }" @click="drawer = false">
                            <el-icon><PictureIcon /></el-icon> 展示
                        </router-link>
                        <router-link to="/tools" class="nav-item" :class="{ 'active': currentRoute === '/tools' }" @click="drawer = false">
                            <el-icon><Tools /></el-icon> 工具
                        </router-link>
                        <router-link to="/free" class="nav-item" :class="{ 'active': currentRoute === '/free' }" @click="drawer = false">
                            <el-icon><Compass /></el-icon> 自由
                        </router-link>
                        <router-link to="/tutorial" class="nav-item" :class="{ 'active': currentRoute.startsWith('/tutorial') }" @click="drawer = false">
                            <el-icon><Document /></el-icon> 资料
                        </router-link>
                        <router-link to="/" class="nav-item" @click="drawer = false">
                            <el-icon><Warning /></el-icon> 举报
                        </router-link>
                        <router-link to="/about" class="nav-item" :class="{ 'active': currentRoute === '/about' }" @click="drawer = false">
                            <el-icon><InfoFilled /></el-icon> 关于
                        </router-link>
                    </div>
                </el-drawer>
                <div class="nav-items" v-show="!isMobile">
                    <router-link to="/" class="nav-item" :class="{ 'active': isHomePage }">
                        <el-icon><House /></el-icon> 首页
                    </router-link>
                    <router-link to="/price" class="nav-item" :class="{ 'active': currentRoute === '/price' }">
                        <el-icon><PriceTag /></el-icon> 价格
                    </router-link>
                    <router-link to="/display" class="nav-item" :class="{ 'active': currentRoute === '/display' }">
                        <el-icon><PictureIcon /></el-icon> 展示
                    </router-link>
                    <router-link to="/tools" class="nav-item" :class="{ 'active': currentRoute === '/tools' }">
                        <el-icon><Tools /></el-icon> 工具
                    </router-link>
                    <router-link to="/free" class="nav-item" :class="{ 'active': currentRoute === '/free' }">
                        <el-icon><Compass /></el-icon> 自由
                    </router-link>
                    <router-link to="/tutorial" class="nav-item" :class="{ 'active': currentRoute.startsWith('/tutorial') }">
                        <el-icon><Document /></el-icon> 资料
                    </router-link>
                    <router-link to="/" class="nav-item">
                        <el-icon><Warning /></el-icon> 举报
                    </router-link>
                    <router-link to="/about" class="nav-item" :class="{ 'active': currentRoute === '/about' }">
                        <el-icon><InfoFilled /></el-icon> 关于
                    </router-link>
                </div>
            </div>
        </div>
    </div>
    <div class="nav-banner" :class="{ 'hide': !showBanner }">
        <router-link to="/tools" class="nav-banner-text" @click="showBanner = false">🎉 经验计算、批量注册工具重磅上线！快人一步，领先一步！></router-link>
    </div> 
    <el-backtop :right="100" :bottom="100" v-show="!isMobile">
            <div>
                <el-icon style="font-size: 20px"><Top /></el-icon>
            </div>
    </el-backtop>
</template>

<script>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { House, PriceTag, Compass, Document, Warning, InfoFilled, Top, Picture as PictureIcon, Tools } from '@element-plus/icons-vue';
import { useWindowSize } from '@vueuse/core';
import { ElButton, ElDrawer, ElIcon} from 'element-plus';
import { useRoute } from 'vue-router';

export default {
    name: "AppHeader",
    components: {
        ElButton,
        ElDrawer,
        ElIcon,
        House,
        PriceTag,
        Compass,
        Document,
        Warning,
        InfoFilled,
        Top,
        PictureIcon,
        Tools
    },
    setup() {
        const drawer = ref(false);
        const { width } = useWindowSize();
        const isMobile = computed(() => width.value < 768);
        const showBackToTop = ref(false);
        const showBanner = ref(true);
        const route = useRoute();

        const isHomePage = computed(() => route.path === '/');
        const currentRoute = computed(() => route.path);

        const checkScroll = () => {
            showBackToTop.value = window.scrollY > 100;
        };

        const scrollToTop = () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        };

        onMounted(() => {
            window.addEventListener('scroll', checkScroll);
            checkScroll();
            
            setTimeout(() => {
                showBanner.value = false;
            }, 4000);
        });

        onUnmounted(() => {
            window.removeEventListener('scroll', checkScroll);
        });

        return {
            drawer,
            isMobile,
            scrollToTop,
            showBackToTop,
            showBanner,
            isHomePage,
            currentRoute
        };
    }
}

// setTimeout(() => {
//     document.querySelector('.nav-banner').classList.add('not-show')
// }, 4000)

</script>

<style scoped>
.nav {
    top: 0;
    display: flex;
    width: 100%;
    left: 0;
    position: fixed;
    justify-content: center;
    flex-direction: column;
    background: var(--adil-navbg);
    align-items: center;
    z-index: 4;
    transition: .3s ease-in-out;
    backdrop-filter: blur(10px);
    box-shadow: 0 2px 4px -1px rgba(0, 122, 255, 0.2);
    border-bottom: 1px solid rgba(0, 122, 255, 0.2);
    height: 50px; /* 固定高度 */
}
.nav.top {
    background: var(--adil-card-bg)
}


a {
    text-decoration: none;
    -webkit-user-drag: none
}

.nav-item {
    display: flex; /* 使图标和文字在同一行 */
    align-items: center; /* 垂直居中对齐 */
    color: var(--adil-fontcolor);
    transition: .3s ease-in-out;
    font-size: 14px;
    margin: 0 2px;
    padding: 4px 8px;
    border-radius: 16px;
    letter-spacing:8px;
    font-weight:700;
    line-height:35px;
    text-align: center;
    text-shadow: .05rem .05rem .1rem transparent;
    position: relative;
}
.nav-item::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 2px;
    background: var(--adil-theme);
    transition: all 0.3s ease;
    transform: translateX(-50%);
}
.nav-item:hover::after,
.nav-item.router-link-active::after {
    width: 100%;
}
.nav-item.router-link-active {
    color: inherit;
    background: inherit;
}
.nav-item.router-link-active::after {
    width: 0;
}
.nav-center {
    display: flex;
    text-align: center;
}
.nav-item:hover {
    background: var(--adil-card-bg);
    color: var(--adil-fontcolor)
}

.nav.top a.nav-item:hover {
    background: var(--adil-secondbg)
}

.nav.top span.site-name {
    color: var(--adil-fontcolor)
}
.nav-content {
    max-width: 1200px;
    width: 90%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    z-index: 2;
    transition: .3s ease-in-out
}
.nav-banner {
    width: 100%;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 50px;
    left: 0;
    z-index: 3;
    background: var(--adil-theme);
    opacity: 0;
    visibility: hidden;
    transform: translateY(-20px);
    transition: all 0.8s ease-in-out;
}

.nav-banner:not(.hide) {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
}

.nav-banner a {
    font-size: 12px;
    color: #fff;
    transition: color 0.3s ease-in-out;
}


.nav-banner-text {
    text-decoration: none;
}

.menu-button {
    display: none;
}

.drawer-content {
    display: flex;
    flex-direction: column;
    padding: 20px;
}
.nav-items {
    display: flex;
}
@media (max-width: 768px) {
    .nav-center .nav-items {
        display: none;
    }
    .menu-button {
        display: block;
    }
}

.nav-right {
    display: flex;
    align-items: center;
}

.back-to-top-button {
    padding: 8px;
    color: var(--adil-fontcolor);
    opacity: 0.8;
    transition: .3s ease-in-out;
}

.back-to-top-button:hover {
    opacity: 1;
    background: var(--adil-secondbg);
}

.mobile-buttons {
    display: flex;
    gap: 10px;
    align-items: center;
}

.menu-button, .back-to-top-button {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 8px 12px;
    color: var(--adil-fontcolor);
    opacity: 0.8;
    transition: .3s ease-in-out;
    font-size: 14px;
}

.menu-button:hover, .back-to-top-button:hover {
    opacity: 1;
    background: var(--adil-secondbg);
}

@media (max-width: 768px) {
    .nav-center .nav-items {
        display: none;
    }
    .mobile-buttons {
        display: flex;
    }
}

/* 在首页时禁用所有选中效果 */
.nav.top[data-is-home="true"] .nav-item.active {
    color: var(--adil-fontcolor);
    background: transparent;
}

.nav.top[data-is-home="true"] .nav-item.active::after {
    width: 0;
}

.nav-item.active {
    color: var(--adil-theme);
    background: var(--adil-secondbg);
}

.nav-item.active::after {
    width: 100%;
}
</style>